import { Skeleton } from "@mui/material";
import useTitanApp from "@/hooks/useTitanApp";

export default function LocationsSettingsSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const isDarkMode = darkMode;

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "", height: 40 };

  const mockLocations = Array(2).fill(null);
  const mockRooms = Array(2).fill(null);

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton
          animation="wave"
          variant="text"
          width={150}
          height={32}
          sx={skeletonSx}
        />
      </div>

      <div className="space-y-6">
        {mockLocations.map((_, locIndex) => (
          <div
            key={locIndex}
            className={`border rounded-lg overflow-hidden ${
              isDarkMode
                ? "border-gray-700 bg-gray-800"
                : "border-gray-200 bg-white"
            }`}
          >
            {/* Location Header */}
            <div className={`p-4 ${isDarkMode ? "bg-gray-700" : "bg-gray-50"}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="flex-1 space-y-2">
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={200}
                    height={24}
                    sx={skeletonSx}
                  />
                  <Skeleton
                    animation="wave"
                    variant="text"
                    width={250}
                    height={16}
                    sx={skeletonSx}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={36}
                    height={36}
                    className="rounded"
                    sx={skeletonSx}
                  />
                </div>
              </div>
            </div>

            {/* Rooms Section */}
            <div
              className={`p-4 ${
                isDarkMode ? "bg-gray-800" : "bg-white"
              } space-y-3`}
            >
              <div className="flex items-center justify-between mb-4">
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={140}
                  height={20}
                  sx={skeletonSx}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={100}
                  height={28}
                  className="rounded"
                  sx={skeletonSx}
                />
              </div>

              {mockRooms.map((_, roomIndex) => (
                <div
                  key={roomIndex}
                  className={`border rounded-lg p-3 ${
                    isDarkMode
                      ? "border-gray-600 bg-gray-700"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1 space-y-1">
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={180}
                        height={20}
                        sx={skeletonSx}
                      />
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={220}
                        height={16}
                        sx={skeletonSx}
                      />
                      <Skeleton
                        animation="wave"
                        variant="text"
                        width={200}
                        height={14}
                        sx={skeletonSx}
                      />
                    </div>
                    <div className="flex items-center gap-2">
                      <Skeleton
                        animation="wave"
                        variant="rectangular"
                        width={28}
                        height={28}
                        className="rounded"
                        sx={skeletonSx}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
